import { Hit } from '@algolia/client-search';

export function AlgoliaHitToObject<T>(items: Hit<T>[]) {
  if (items) {
    return items.map((item) => ({
      ...item,
      _id: item.objectID,
    }));
  }
  return [];
}
